import {
  FIRST_GOAL_SETTINGS_STEP_SLUG,
  FIRST_DIET_SETTINGS_STEP_SLUG,
  FIRST_BIOMETRIC_SETTINGS_STEP_SLUG,
} from '../consts';

const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: `/diet-settings/goalSettings/${FIRST_GOAL_SETTINGS_STEP_SLUG}`,
    translationKey: dummy_t('menu.dietSettings.goal'),
  },
  {
    path: `/diet-settings/biometric/${FIRST_BIOMETRIC_SETTINGS_STEP_SLUG}`,
    translationKey: dummy_t('menu.dietSettings.user'),
  },
  {
    path: `/diet-settings/all/${FIRST_DIET_SETTINGS_STEP_SLUG}`,
    translationKey: dummy_t('menu.dietSettings.all'),
  },
];
